import React from "react";
import SelectionPage from "../../Components/SelectionPage";

const SelectedAgent = ({ magicCode, userDetails, setMagicCode }) => {
  console.log("userDetails", userDetails);
  return (
    <SelectionPage
      setMagicCode={setMagicCode}
      magicCode={magicCode}
      userDetails={userDetails}
    />
  );
};

export default SelectedAgent;
